<div class="oauth-page">
  <header class="oauth-header">
    <div>
      <h2 class="oauth-title">OAuth</h2>
      <p class="oauth-subtitle">
        Separa aplicaciones conectadas (quién tiene acceso) y permisos (qué pueden hacer). Revocar una app corta sus tokens; los scopes
        desaparecen de esa app al revocarla.
      </p>
    </div>
    <button mat-stroked-button type="button" (click)="refresh()" [disabled]="!can_manage()">
      <mat-icon>refresh</mat-icon>
      Actualizar
    </button>
  </header>

  <section class="oauth-section" aria-labelledby="oauth-apps-title">
    <div class="oauth-section-header">
      <h3 id="oauth-apps-title" class="oauth-section-title">Aplicaciones</h3>
      <p class="oauth-section-subtitle">Clientes OAuth con tokens activos (MCP, webmail, intranet…).</p>
    </div>

    @if (applications().length === 0) {
      <div class="oauth-empty">
        <mat-icon>apps</mat-icon>
        <p>No hay aplicaciones conectadas.</p>
      </div>
    } @else {
      <ul class="oauth-list">
        @for (application of applications(); track application.client_id) {
          <li class="oauth-row">
            <div class="oauth-row-main">
              <p class="oauth-client-name">{{ application.client_name }}</p>
              <p class="oauth-meta">
                {{ application.tokens_count }} token(s)
                @if (application.latest_expires_at) {
                  · Caduca {{ application.latest_expires_at | date: 'short' }}
                }
              </p>
              @if (application.is_intranet_spa) {
                <p class="oauth-meta">Sesión de la intranet Bisual.</p>
              }
            </div>
            @if (can_manage() && application.is_intranet_spa) {
              <button mat-stroked-button color="warn" type="button" (click)="logout()" [disabled]="logging_out()">
                <mat-icon>logout</mat-icon>
                Cerrar sesión
              </button>
            } @else if (can_manage() && application.is_revocable) {
              <button
                mat-stroked-button
                color="warn"
                type="button"
                (click)="revoke(application)"
                [disabled]="revoking_client_id() === application.client_id"
              >
                <mat-icon>link_off</mat-icon>
                Revocar
              </button>
            }
          </li>
        }
      </ul>
    }
  </section>

  <section class="oauth-section" aria-labelledby="oauth-scopes-title">
    <div class="oauth-section-header">
      <h3 id="oauth-scopes-title" class="oauth-section-title">Scopes</h3>
      <p class="oauth-section-subtitle">Permisos concedidos a través de las aplicaciones de arriba.</p>
    </div>

    @if (scopes().length === 0) {
      <div class="oauth-empty">
        <mat-icon>lock_open</mat-icon>
        <p>No hay scopes concedidos todavía.</p>
      </div>
    } @else {
      <ul class="oauth-list">
        @for (scope of scopes(); track scope.scope_id) {
          <li class="oauth-row">
            <div class="oauth-row-main">
              <p class="oauth-client-name">
                <code>{{ scope.scope_id }}</code>
              </p>
              <p class="oauth-meta">{{ scope.label }}</p>
              @if (scope.application_names_label) {
                <p class="oauth-meta">En: {{ scope.application_names_label }}</p>
              }
            </div>
            <span class="scope-badge" [class.scope-badge-on]="scope.is_granted">
              {{ scope.is_granted ? 'Concedido' : 'Pendiente' }}
            </span>
          </li>
        }
      </ul>
    }

    @if (show_mail_read_pending()) {
      <div class="scope-hint">
        <p>
          Falta <code>mail:read</code> para buscar correo vía MCP. Vuelve a autorizar el cliente MCP del IDE; el consentimiento incluye
          correo.
        </p>
        @if (mail_reauthorize_hint()) {
          <p>{{ mail_reauthorize_hint() }}</p>
        }
      </div>
    }
  </section>
</div>
